import { Box, Typography } from "@mui/material";
import LogoImage from "../../images/logo/logo.png";
import { APP_NAME } from "../../constants/brand";

function AuthPageLayout({
    sideImage,
    sideTitle,
    sideSubtitle,
    badge,
    title,
    children,
    footer,
    mediaFirst = true,
}) {
    return (
        <Box className="auth-page">
            {mediaFirst ? (
                <>
                    <Box className="auth-page__media max-sm:hidden">
                        <img src={sideImage} alt="" className="auth-page__media-img" />
                        <Box className="auth-page__media-overlay" />
                        {(sideTitle || sideSubtitle) && (
                            <Box className="auth-page__media-caption">
                                {sideTitle ? (
                                    <Typography component="h2" className="auth-page__media-title">
                                        {sideTitle}
                                    </Typography>
                                ) : null}
                                {sideSubtitle ? (
                                    <Typography className="auth-page__media-subtitle">{sideSubtitle}</Typography>
                                ) : null}
                            </Box>
                        )}
                    </Box>
                    <Box className="auth-page__panel login-panel-enter">
                        {badge ? <span className="auth-page__badge">{badge}</span> : null}
                        <Box className="auth-logo-card">
                            <img src={LogoImage} alt={APP_NAME} className="auth-logo" />
                        </Box>
                        {title ? (
                            <Typography variant="h5" className="auth-page__title">
                                {title}
                            </Typography>
                        ) : null}
                        <Box className="auth-page__body">{children}</Box>
                        {footer ? <Box className="auth-login-footer">{footer}</Box> : null}
                    </Box>
                </>
            ) : (
                <>
                    <Box className="auth-page__panel login-panel-enter">
                        {badge ? <span className="auth-page__badge">{badge}</span> : null}
                        <Box className="auth-logo-card">
                            <img src={LogoImage} alt={APP_NAME} className="auth-logo" />
                        </Box>
                        {title ? (
                            <Typography variant="h5" className="auth-page__title">
                                {title}
                            </Typography>
                        ) : null}
                        <Box className="auth-page__body">{children}</Box>
                        {footer ? <Box className="auth-login-footer">{footer}</Box> : null}
                    </Box>
                    <Box className="auth-page__media max-sm:hidden">
                        <img src={sideImage} alt="" className="auth-page__media-img" />
                        <Box className="auth-page__media-overlay" />
                        {(sideTitle || sideSubtitle) && (
                            <Box className="auth-page__media-caption">
                                {sideTitle ? (
                                    <Typography component="h2" className="auth-page__media-title">
                                        {sideTitle}
                                    </Typography>
                                ) : null}
                                {sideSubtitle ? (
                                    <Typography className="auth-page__media-subtitle">{sideSubtitle}</Typography>
                                ) : null}
                            </Box>
                        )}
                    </Box>
                </>
            )}
        </Box>
    );
}

export default AuthPageLayout;
